import routes from '../routes';

import { generateUpdateActionCreator, generateCreateActionCreator } from "actions/crudActionCreators";
import ACTION_NAMES from "actions/ACTION_NAMES";

export default {
    update: generateUpdateActionCreator(routes.API_UPDATE_CUSTOMER_PIPELINE, ACTION_NAMES.CUSTOMER_PIPELINE),
    create: generateCreateActionCreator(routes.API_CREATE_CUSTOMER_PIPELINE, ACTION_NAMES.CUSTOMER_PIPELINE)
};
